import { Toaster } from "../src/components/ui/toaster";
import { Flex } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import Header from "./components/custom/Header";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Footer from "./components/custom/Footer";
import AboutScreen from "./screens/AboutScreen";
import ContactScreen from "./screens/ContactScreen";
import AllServicesScreen from "./screens/AllServicesScreen";
import ErrorScreen from "./screens/ErrorScreen";
import { HelmetProvider } from "react-helmet-async";

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster />
        <FloatingWhatsApp
          accountName="Glory Services"
          phoneNumber="919152832898"
          statusMessage="Online"
          avatar="../assets/avatar.png"
          allowClickAway={true}
          allowEsc={true}
          chatboxStyle={{ color: "#54656f" }}
        />
        <Header />
        <Flex direction="column" as="main" bgColor="white">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/about" element={<AboutScreen />} />
            <Route path="/services" element={<AllServicesScreen />} />
            <Route path="/contact" element={<ContactScreen />} />
            <Route path="*" element={<ErrorScreen />} />
          </Routes>
        </Flex>
        <Footer />
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
